import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-yes-no-dialog',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    TranslatePipe,
  ],
  templateUrl: './yes-no-dialog.component.html',
})
export class YesNoDialogComponent {
  yes: () => void;
  no: () => void;
  text: string;
  yesButtonText: string;
  noButtonText: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      text: string;
      yesButtonText: string;
      noButtonText: string;
      yes: () => void;
      no: () => void;
    },
  ) {
    this.text = data.text;
    this.yes = data.yes;
    this.no = data.no;
    this.yesButtonText = data.yesButtonText;
    this.noButtonText = data.noButtonText;
  }
}
